export default __webpack_public_path__ + "static/media/STR_.99bd17b1.jpg";